<div class="side-nav-list-container">
  <mat-nav-list (click)="gotoHome()">
    <mat-list-item class="side-nav-list-item">
      <div class="side-nav-list-item-box">
        <div class="side-nav-list-item-icon">
          <mat-icon mat-list-icon>home</mat-icon>
        </div>
        @if (isSideNavOpened) {
        <div class="side-nav-list-item-text">Home</div>
        }
      </div>
    </mat-list-item>
  </mat-nav-list>
  <mat-nav-list >
    <mat-list-item class="side-nav-list-item">
      <div class="side-nav-list-item-box">
        <div class="side-nav-list-item-icon">
          <mat-icon mat-list-icon>grid_view</mat-icon>
        </div>
        @if (isSideNavOpened) {
        <div class="side-nav-list-item-text">Borrowers</div>
        }
      </div>
    </mat-list-item>
  </mat-nav-list>
  <mat-nav-list class="side-nav-list-last-item">
    <mat-list-item class="side-nav-list-item">
      <div class="side-nav-list-item-box">
        <div class="side-nav-list-item-icon">
          <mat-icon mat-list-icon>settings</mat-icon>
        </div>
        @if (isSideNavOpened) {
        <div class="side-nav-list-item-text">Settings</div>
        }
      </div>
    </mat-list-item>
  </mat-nav-list>
  <mat-divider></mat-divider>
  <mat-nav-list (click)="toggleSidenav()">
    <mat-list-item class="side-nav-list-item">
      <div class="side-nav-list-item-box">
        <div class="side-nav-list-item-icon">
          <mat-icon mat-list-icon [svgIcon]="'right_panel_close'"></mat-icon>
        </div>
        @if (isSideNavOpened) {
        <div class="side-nav-list-item-text">Close</div>
        }
      </div>
    </mat-list-item>
  </mat-nav-list>
</div>